import { useSelector } from "react-redux";
import { AppState } from "../../redux/types";
import { cn } from "../../utils/commonFunctions";

// Two-letter initials: first + last word, or the first two letters of a single name
const getInitials = (name: string) => {
  const words = name.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return "--";
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return `${words[0][0]}${words[words.length - 1][0]}`.toUpperCase();
};

const Avatar = ({ size = "md" }: { size?: "md" | "lg" }) => {
  const name = useSelector((state: AppState) => state?.user?.myProfile?.name ?? "--");

  return (
    <span
      className={cn(
        "flex shrink-0 select-none items-center justify-center rounded-full bg-gradient-to-br from-[#E1383B] to-[#C42B2E] font-semibold text-white shadow-sm ring-2 ring-white",
        size === "lg" ? "h-12 w-12 text-base" : "h-10 w-10 text-sm"
      )}
    >
      {getInitials(name)}
    </span>
  );
};

export default Avatar;
